import { useEffect, useState } from 'react';
import axios from 'axios';

const useThirdPartyCookieCheck = () => {
  const [isSupported, setIsSupported] = useState<null | boolean>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const frame = document.createElement('iframe');
    function get3PCStatusMessage(event: MessageEvent) {
      if (event.origin !== 'https://brokerbay.github.io') {
        return;
      }

      if (event.data === '3PCsupported' || event.data === '3PCunsupported') {
        setIsSupported(event.data === '3PCsupported');
        setLoading(false);
        document.body.removeChild(frame);
        window.removeEventListener('message', get3PCStatusMessage);
      }
    }

    const src = process.env.TPC_CHECK_URL as string;
    frame.src = src;
    frame.id = 'third-party-iframe';
    frame.style.display = 'none';
    frame.style.position = 'fixed';
    document.body.appendChild(frame);

    window.addEventListener('message', get3PCStatusMessage);

    return () => {
      if (loading) {
        const ThirdPartyframe = document.getElementById('third-party-iframe');
        if (ThirdPartyframe) document.removeChild(ThirdPartyframe);
        window.removeEventListener('message', get3PCStatusMessage);
      }
    };
  }, []);
  return [loading, isSupported];
};

export default useThirdPartyCookieCheck;
